import './scroll-to-top.scss'

class ScrollToTopButton {
 
  constructor() {
    this.scrollToTopButton = null;
    this.scrollOffset = 250;
    this.mediaQuery = window.matchMedia('(min-width: 768px)');
    this.init();
  }
  
  init() {
    if (this.mediaQuery.matches) {
      document.addEventListener("DOMContentLoaded", () => {
        this.setup();
        this.setupScrollHandler();
      });
    }
  }

  setup() {
    this.scrollToTopButton = document.querySelector('.stt');
    if (!this.scrollToTopButton) {
      return;
    }
    this.checkScrollPosition();
  }

  setupScrollHandler() {
    window.addEventListener('scroll', () => {
      this.toggleButtonVisibility();
    });
  }

  checkScrollPosition() {
    if (window.scrollY > this.scrollOffset) {
      this.toggleButtonVisibility();
    }
  }

  toggleButtonVisibility() {
    if (window.scrollY > this.scrollOffset) {
      this.scrollToTopButton.classList.add('stt--visible');
    } else {
      this.scrollToTopButton.classList.remove('stt--visible');
    }
  }
}

const scrollToTop = new ScrollToTopButton();